import { trackElementInteraction } from 'frontend/shared/javascripts/util/analytics'

interface AnalyticsTrackClickEvent extends Event {
  eventData?: Record<string, unknown>
}

up.on(
  'analytics:track-click',
  (event: AnalyticsTrackClickEvent, target: HTMLElement | undefined) => {
    if (target != null) {
      trackElementInteraction(target, 'click.element', event.eventData)
    }
  },
)
